import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { actionCreators, selectors } from "store/actions/mymazda"
import { withRadium } from "higher-order-components"
import { Section } from "AtomicComponents"
import { MyMazdaServiceRequest } from "AtomicContainers"

const MyMazdaServiceRequestFormBlock = props => (
  <Section padding backgroundColor="#ffffff">
    <MyMazdaServiceRequest {...props} />
  </Section>
)

const mapStateToProps = (state, props) => ({
  service: props.serviceOptions ? selectors.getService(props.serviceOptions.vehicle.vin)(state) : {}
})

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch)

export default withRadium(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(MyMazdaServiceRequestFormBlock)



// WEBPACK FOOTER //
// ./src/blocks/mymazda/service/form.jsx